import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { NewsletterListSearchCriteria } from '../models/newsletter.model';

import { NewsletterEndpoint } from '../constants/newsletter-endpoint';

import { NewsletterListStateModel } from './newsletter-list.state';

@Injectable({
  providedIn: 'root',
})
export class NewsletterListService {
  constructor(private http: WrapperHttpService) {}

  getNewsletterList(searchCriteria: NewsletterListSearchCriteria): Observable<NewsletterListStateModel> {
    const url = `${API_URL}${NewsletterEndpoint.Base}?` + getQueryStringFromObject(searchCriteria);
    return this.http.withLoading().get<NewsletterListStateModel>(url);
  }
}
